// Módulo y Sección/Área ya NO se hardcodean aquí -- tienen catálogo real en BD
// (CODE_AIPromptModule / CODE_AIPromptSection) expuesto por
// AIPromptConfigurationController.GetModulosCatalogoAsync / GetSeccionesCatalogoAsync, ver
// api.getModulosCatalogo / api.getSeccionesCatalogo. Se cargan en tiempo de ejecución en
// Main.vue y CreateEditForm.vue.

// CurriculoReferencia es hoy texto libre sin catálogo en BD (no hay CODE_AIPromptCurriculo) --
// esta lista es solo para ofrecer un select consistente en el formulario; el campo en sí sigue
// guardándose como string simple. Ver conversación "Contexto de aplicación" (24 ago 2026): en
// pausa la decisión de si esto se vuelve un filtro operacional real -- por ahora es un valor
// descriptivo, de un solo valor por versión, no una selección múltiple.
export const CURRICULOS_REFERENCIA = [
  { value: 'Regular', text: 'Regular' },
  { value: 'Expandido', text: 'Expandido' },
  { value: 'Académico-funcional', text: 'Académico-funcional' },
];

// Catálogo de fuentes de enum "en vivo" que puede declarar una clave del ResponseJsonSchema
// vía CODE_AIPromptConfiguration.EnumSourcesJson (ej. {"aprovechamiento":"NivelFuncionamiento"}).
// Espejo del enum cerrado real EduEsp.Business.Entities/Enums/PeiAIEnumSource.cs -- el Orquestador
// (ResolveResponseJsonSchemaAsync) lanza una excepción explícita si EnumSourcesJson declara algo
// que no esté en ese enum -- por eso esta lista NO se amplía aquí sin agregar primero el valor
// real al enum y su resolver.
//
// Sin valores actualmente -- ningún catálogo real está listo todavía.
export const ENUM_SOURCES_CATALOG = [{ value: '', text: '— texto libre —' }];
